import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- Service ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/services/list',
    name: 'pages-services-list',
    component: () => import('@/views/pages/service/ServiceList.vue'),
    meta: {
      resource: 'service',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('services.mainVerticalMenu.services'),
    },
  },
  {
    path: '/services/add',
    name: 'pages-services-add',
    component: () => import('@/views/pages/service/ServiceAdd.vue'),
    meta: {
      resource: 'service',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('services.addHeaderTitle'),
    },
  },
  {
    path: '/services/edit/:id',
    name: 'pages-services-edit',
    component: () => import('@/views/pages/service/ServiceEdit.vue'),
    meta: {
      resource: 'service',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('services.editHeaderTitle'),
    },
  },
  {
    path: '/services/categories/list',
    name: 'pages-services-categories-list',
    component: () => import('@/views/pages/serviceCategory/ServiceCategoryList.vue'),
    meta: {
      resource: 'serviceCategory',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('serviceCategories.mainVerticalMenu.serviceCategories'),
    },
  },
  {
    path: '/services/categories/add',
    name: 'pages-services-categories-add',
    component: () => import('@/views/pages/serviceCategory/ServiceCategoryAdd.vue'),
    meta: {
      resource: 'serviceCategory',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('serviceCategories.addHeaderTitle'),
    },
  },
  {
    path: '/services/categories/edit/:id',
    name: 'pages-services-categories-edit',
    component: () => import('@/views/pages/serviceCategory/ServiceCategoryEdit.vue'),
    meta: {
      resource: 'serviceCategory',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('serviceCategories.editHeaderTitle'),
    },
  },
]
